import { useQueries } from "@tanstack/react-query";

import { getKBEquipmentType } from "@/lib/api/agent";

/** Component display name from a live KB map (component id → name_fi). */
export function componentLabel(
  component_id: string,
  extra?: Record<string, string>,
): string {
  return extra?.[component_id] ?? component_id;
}

/** Load component id → name_fi for the given equipment types. */
export function useKbComponentLabels(
  equipmentTypes: Array<string | null | undefined>,
): Record<string, string> {
  const types = [...new Set(equipmentTypes.filter(Boolean))] as string[];
  const queries = useQueries({
    queries: types.map((equipmentType) => ({
      queryKey: ["kb-equipment-type", equipmentType],
      queryFn: () => getKBEquipmentType(equipmentType),
      staleTime: Infinity,
    })),
  });
  const labels: Record<string, string> = {};
  for (const query of queries) {
    for (const component of query.data?.components ?? []) {
      if (component.name_fi) labels[component.id] ??= component.name_fi;
    }
  }
  return labels;
}
